import React from 'react'

const IconChevronLeft = ({ width = '24px', height = '24px' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
      <path
        d="M14.2426407,4.34314575 L15.6568542,5.75735931 L9.29246609,12.1211458 L15.6568542,18.4852814 L14.2426407,19.8994949 L6.46446609,12.1213203 L7.87867966,10.7071068 L7.87846609,10.7071458 L14.2426407,4.34314575 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconChevronLeft
